import { createAction, props } from '@ngrx/store';
export const canActivate = createAction(
  '[Vacancy Without Paid Product Guard] Can Activate',
  props<{ vacancyId: string }>()
);
